import { render, staticRenderFns } from "./MailBox.vue?vue&type=template&id=bcd77d0e&scoped=true&"
import script from "./MailBox.vue?vue&type=script&lang=js&"
export * from "./MailBox.vue?vue&type=script&lang=js&"
import style0 from "./MailBox.vue?vue&type=style&index=0&id=bcd77d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd77d0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcd77d0e')) {
      api.createRecord('bcd77d0e', component.options)
    } else {
      api.reload('bcd77d0e', component.options)
    }
    module.hot.accept("./MailBox.vue?vue&type=template&id=bcd77d0e&scoped=true&", function () {
      api.rerender('bcd77d0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/mails/MailBox.vue"
export default component.exports